module.exports = __webpack_public_path__ + "static/media/242 Park - Exterior Draft 2.b1f47ef4.jpg";